export enum TransactionType {
  BUY = 'BUY',
  SELL = 'SELL',
  EXCHANGE_TRADE = 'EXCHANGE_TRADE',
}